import React from 'react';
import { Filter } from '../Filter';

const FilterGroupFilters = ({ filterGroups, group, onBlur }) =>
  (filterGroups[group.id] || []).map((filter) => (
    <Filter key={filter.id} filter={filter} onBlur={onBlur} />
  ));

export default FilterGroupFilters;
